<div class="zk-flex zk-items-center zk-gap-2" tabindex="0">
	<div class="zk-relative ">
		<freud-avatar [label]="user.image ? 'User avatar' : ''" size="md" [image]="user.image"></freud-avatar>
		<freud-badge
			class="avatar__badge"
			[color]="isUserVisible ? 'success' : 'error'"
		></freud-badge>
	</div>
	<span class="freud-icon freud-icon-chevron-down freud-icon-md"> </span>
</div>
